import * as React from 'react';
import { Image } from '../Image';
import styles from './VideoPreview.css';
import { PlayButton } from './components/PlayButton';
import { getVideoPreview } from './utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var VideoPreview = /*#__PURE__*/React.forwardRef(function Video(props, ref) {
  var _props$backgroundSize = props.backgroundSize,
      backgroundSize = _props$backgroundSize === void 0 ? 'cover' : _props$backgroundSize,
      _props$showPlayButton = props.showPlayButton,
      showPlayButton = _props$showPlayButton === void 0 ? true : _props$showPlayButton,
      priority = props.priority;
  var previewUrl = getVideoPreview(props);
  return /*#__PURE__*/_jsxs("div", {
    className: styles['container'],
    ref: ref,
    children: [previewUrl && /*#__PURE__*/_jsx(Image, {
      priority: priority,
      objectFit: backgroundSize,
      src: previewUrl
    }), showPlayButton && /*#__PURE__*/_jsx(PlayButton, {})]
  });
});